/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FileUploadDto } from './FileUploadDto';
import {
    FileUploadDtoFromJSON,
    FileUploadDtoFromJSONTyped,
    FileUploadDtoToJSON,
} from './FileUploadDto';

/**
 * 
 * @export
 * @interface ExamenEntreeFichierUploadDto
 */
export interface ExamenEntreeFichierUploadDto {
    /**
     * 
     * @type {FileUploadDto}
     * @memberof ExamenEntreeFichierUploadDto
     */
    file?: FileUploadDto;
    /**
     * 
     * @type {number}
     * @memberof ExamenEntreeFichierUploadDto
     */
    idexamenEntreeFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof ExamenEntreeFichierUploadDto
     */
    idexamenEntree?: number;
    /**
     * 
     * @type {number}
     * @memberof ExamenEntreeFichierUploadDto
     */
    idfichier?: number;
    /**
     * 
     * @type {number}
     * @memberof ExamenEntreeFichierUploadDto
     */
    idtypeAcquisFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof ExamenEntreeFichierUploadDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the ExamenEntreeFichierUploadDto interface.
 */
export function instanceOfExamenEntreeFichierUploadDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExamenEntreeFichierUploadDtoFromJSON(json: any): ExamenEntreeFichierUploadDto {
    return ExamenEntreeFichierUploadDtoFromJSONTyped(json, false);
}

export function ExamenEntreeFichierUploadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExamenEntreeFichierUploadDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': !exists(json, 'file') ? undefined : FileUploadDtoFromJSON(json['file']),
        'idexamenEntreeFichier': !exists(json, 'idexamenEntreeFichier') ? undefined : json['idexamenEntreeFichier'],
        'idexamenEntree': !exists(json, 'idexamenEntree') ? undefined : json['idexamenEntree'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'idtypeAcquisFichier': !exists(json, 'idtypeAcquisFichier') ? undefined : json['idtypeAcquisFichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function ExamenEntreeFichierUploadDtoToJSON(value?: ExamenEntreeFichierUploadDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': FileUploadDtoToJSON(value.file),
        'idexamenEntreeFichier': value.idexamenEntreeFichier,
        'idexamenEntree': value.idexamenEntree,
        'idfichier': value.idfichier,
        'idtypeAcquisFichier': value.idtypeAcquisFichier,
        'fileName': value.fileName,
    };
}

